import { logoutSession } from './eventEmitter/logoutEmitter';

export const Signout = () => {
  window.location.replace('/');
};
